<template>
  <div class="container">
    <div class="drawer-wraper" @click="showCity">
      <span class="some_tip">{{formItem.title}}</span>
      <p>
        <span class="some_tip">{{formatValue}}</span>
        <span class="info-arrow"></span>
      </p>
    </div>
    <p
      :class="['status-tip','tip_'+formItem.field_status]"
      v-show="formItem.field_result"
    >{{formItem.field_result}}</p>
    <cube-drawer
      ref="drawer"
      :data="cityList"
      :selected-index="selectedIndex"
      @change="changeHandler"
      @select="checkCommit"
      @cancel="cancelHandler"
    ></cube-drawer>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { post } from "../../tools/request";
import { emitFormUpdate } from "../../tools/utils";
export default {
  props: ["formItem", "idx", "cm"],
  mounted() {
    //如果当前组件无城市传入，则自动定位当前城市
    if (!this.formItem.value && !this._area.value) {
      this.getLocation();
    } else {
      this.formItem.valid = true;
      emitFormUpdate(this, this.idx);
    }
  },
  computed: {
    ...mapState(["_ticket", "_area"]),
    params() {
      return new URLSearchParams(location.search);
    },
    formatValue() {
      let finded = this.cityList[0][this.curIndex];
      return finded ? finded.text : "";
    },
    cityList() {
      //返回数据为{A:[],B:[]}
      let options = this.formItem.options || {};
      //UI 要求多维数组
      return [Object.values(options).reduce((a, c) => a.concat(c), [])];
    },
    curIndex() {
      let val = this.formItem.value || this._area.value;
      return this.cityList[0].findIndex(x => x.value == val);
    },
    selectedIndex() {
      let idx = this.curIndex;
      return idx > -1 ? [idx] : [];
    }
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["setState"]),
    showCity() {
      //已通过则不再允许做操作
      if (this.formItem.field_status == 4) {
        return;
      }
      this.$refs.drawer.show();
    },
    changeHandler(...a) {
      console.log("c", a);
    },
    cancelHandler(...a) {
      console.log("cancel", a);
    },
    setLocateCity(lng, lat) {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      if (!up.get("lng")) {
        up.set("lng", lng);
        up.set("lat", lat);
      }
      post(process.env.GETCITY_URL, up)
        .then(data => {
          this.formItem.value = data.value;
          this.setState({ _area: data,_open_type:data.open_type }); //同步更新vuex
          this.formItem.valid = true;
          emitFormUpdate(this, this.idx);
        })
        .catch(e => {
          console.log(e);
        });
    },
    getLocation() {
      let lng = this.params.get("lng"),
        lat = this.params.get("lat");
      if (lng && lat) {
        this.setLocateCity(lng, lat);
      } else {
        let that = this;
        /**
         *  获取经纬度信息
         *  position_option 获取经纬度信息的配置项
         *  getPositionSuccess 信息获取成功函数
         *  getPositionError 信息获取失败函数
         */
        let position_option = {
          enableHighAccuracy: true, //告诉浏览器是否启用高精度设备
          maximumAge: 30000, //单位毫秒，告诉设备缓存时间，主要用于设备的省电或者节省带宽方面
          timeout: 3000 //超时时间
        };
        navigator.geolocation.getCurrentPosition(
          getPositionSuccess,
          getPositionError,
          position_option
        );
        function getPositionSuccess(position) {
          that.setLocateCity(
            position.coords.longitude,
            position.coords.latitude
          );
        }
        function getPositionError(e) {
          console.log(e, "get position fail!");
        }
      }
    },
    checkCommit(...a) {
      this.formItem.value = a[0][0];
      this.setState({ _area: { value: a[0][0], text: a[2][0] } });
      this.formItem.valid = true;
      emitFormUpdate(this, this.idx);
      //if need add
      if (this.cm) {
        this.addInfo();
      }
    },
    //提交物料
    addInfo() {
      // 更新icon --checking
      this.formItem.field_status = 3;
      this.formItem.field_result = this.$t("检测中");
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let val = this.formItem.value;
      if (this.formItem.clear_format) {
        val = this[this.formItem.format](val, true);
      }
      up.append(this.formItem.key, val);
      post(process.env.ADD_AUDI_INFO, up)
        .then(() => {
          // success do nothing
        })
        .catch(err => {
          this.formItem.field_status = 5;
          this.formItem.field_result = err.errmsg;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-right: 0.36rem;
  margin-bottom: 0.1rem;
  font-size: 0.36rem;
  color: #414141;
  background: #fff;
}
.status-tip {
  width: 7.1rem; //铺满右侧
  margin-right: 0;
}
.drawer-wraper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 1.4rem;
  p {
    max-width: 70%;
    display: flex;
    align-items: center;
    color: #323233;
  }
}
</style>

<style>
.cube-drawer {
  position: fixed !important;
}
.cube-drawer-item_active {
  color: #fc9153;
  background-color: transparent !important;
}
.cube-drawer-item {
  overflow: scroll !important;
}
.cube-drawer-item:after {
  width: 300px !important;
}
</style>
